var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 101,
    fill: "#121212"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 90,
    stroke: "#FF5C00",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 105.286C123.485 105.286 141.714 123.515 141.714 146H146C146 121.147 125.853 101 101 101C76.1471 101 56 121.147 56 146H60.2857C60.2857 123.515 78.5139 105.286 101 105.286Z",
    fill: "#2E2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 56C87.3899 56 76.3574 67.0325 76.3574 80.6429C76.3574 94.2532 87.3899 105.286 101 105.286C114.611 105.286 125.643 94.2532 125.643 80.6429C125.643 67.0325 114.611 56 101 56ZM101 101C89.7567 101 80.6431 91.8864 80.6431 80.6429C80.6431 69.3993 89.7567 60.2857 101 60.2857C112.244 60.2857 121.357 69.3993 121.357 80.6429C121.357 91.8864 112.244 101 101 101Z",
    fill: "#2E2D2D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIcon);
export default __webpack_public_path__ + "static/media/TypeIcon.b87d6962446b30a059b345f8358836e6.svg";
export { ForwardRef as ReactComponent };